import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';
import { normalizeAssetName } from '../../../utils/formatters';

@Component({
  selector: 'icp-badge',
  standalone: true,
  imports: [CommonModule],
  template: ` <span class="badge"><ng-content></ng-content>{{ label }}</span> `,
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent {
  @Input() label: string = '';
  @Input() size: 'sm' | 'md' = 'sm';

  @Input() kind?: 'ativo' | 'normal' | 'isento' | 'inativo' | 'falha';

  private get effectiveKind(): 'ativo' | 'normal' | 'isento' | 'inativo' | 'falha' {
    if (this.kind) return this.kind;
    const normalized = normalizeAssetName(this.label);
    if (normalized === 'ativo') return 'ativo';
    if (normalized === 'isento') return 'isento';
    if (normalized === 'inativo') return 'inativo';
    if (normalized === 'falha') return 'falha';
    return 'normal';
  }

  @HostBinding('style.--badge-color') get sColor() {
    switch (this.effectiveKind) {
      case 'ativo':
        return 'rgba(11, 91, 12, 1)';
      case 'isento':
        return 'rgba(2, 74, 162, 1)';
      case 'inativo':
        return 'rgba(185, 28, 28, 1)';
      case 'normal':
      default:
        return 'rgba(117, 65, 6, 1)';
    }
  }
  @HostBinding('style.--badge-bg') get sBg() {
    switch (this.effectiveKind) {
      case 'ativo':
        return 'rgba(218, 236, 218, 1)';
      case 'isento':
        return 'rgba(214, 233, 255, 1)';
      case 'inativo':
        return 'rgba(254, 226, 226, 1)';
      case 'falha':
        return 'rgba(254, 226, 226, 1)';
      case 'normal':
      default:
        return 'rgba(255, 227, 173, 1)';
    }
  }
  @HostBinding('style.--badge-border') get sBorder() {
    return 'transparent';
  }
  @HostBinding('class.size-sm') get cSm() {
    return this.size === 'sm';
  }
  @HostBinding('class.size-md') get cMd() {
    return this.size === 'md';
  }
}
